<template>
  <div class="transaction-bar flex between al-center pb-21 pt-21">
    <div class="transaction-bar__left-col flex">
      <img :src="transaction.imageURL" />
      <div class="transaction-bar__left-col--text flex column  ml-13">
        <div class="flex mb-3 al-center">
          <span class="f-16 bold pale">{{
            transaction.authDate.substring(0, 10)
          }}</span>
          <span class="f-16 bold pale ml-5">{{
            transaction.authDate.substring(11, 18)
          }}</span>
        </div>
        <span class="f-16 bold">{{ transaction.merchantName }}</span>
      </div>
    </div>
    <div class="transaction-bar__right-col">
      <span
        class="f-16 pangram-extrabold f-red"
        v-if="to_cash && transaction.amount !== 0"
        >- {{ transaction.amount }} ₾</span
      >
      <div class="flex al-center" v-if="!to_cash">
        <span
          class="f-16 pangram-extrabold  mr-3"
          :style="{
            color: transaction.transactionType === 1 ? 'red' : 'green'
          }"
          >{{
            transaction.transactionType === 1
              ? "-" + transaction.points
              : transaction.points
          }}</span
        >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="12.54"
          height="12"
          viewBox="0 0 12.54 12"
        >
          <path
            id="Path_10631"
            data-name="Path 10631"
            d="M6.619,10.486a.749.749,0,0,0-.7,0L3.208,11.912a.75.75,0,0,1-1.088-.79L2.638,8.1a.751.751,0,0,0-.216-.664L.227,5.3A.75.75,0,0,1,.643,4.018l3.034-.441a.75.75,0,0,0,.565-.41L5.6.418a.75.75,0,0,1,1.345,0L8.3,3.167a.75.75,0,0,0,.565.41l3.034.441A.75.75,0,0,1,12.313,5.3l-2.2,2.14A.751.751,0,0,0,9.9,8.1l.518,3.022a.75.75,0,0,1-1.088.79Z"
            fill="#ffcb05"
            fill-rule="evenodd"
          />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    to_cash: Boolean,
    transaction: Object
  },
  watch: {
    to_cash(ns) {
      console.log(ns);
    }
  },
  mounted() {
    console.log(this.to_cash);
  }
};
</script>

<style lang="scss">
.transaction-bar {
  border-bottom: #f0f0f0 1px solid;
  img {
    object-fit: contain;
    width: 50px;
    height: 50px;
  }
  &__left-col {
    .f-16 {
      font-size: 13px;
    }
    &--text {
      .pale {
        color: rgba(#1a1a1a, 0.3);
      }
    }
  }

  @media (max-width: 413px) {
    &__left-col {
      // width: 40px;
      // height: 40px;
      &--text {
        .pale {
          font-size: 13px;
        }
      }
    }
  }
}
</style>
